/**
 * 直接搜索Main可以查看当前页面的主要内容
 */
import React, { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import Cookies from "js-cookie";
import CompeteModal from "@Components/ask/CompeteModal";
import { useQuery } from "react-query";
import { useLocalStorageState, useMount, useSetState } from "ahooks";
import { isObject } from "lodash";
import qs from "qs";
import { Modal } from "@t8891/pc-v1";
import {
  fetchInquiry,
  fetchInquiryBuyCarInformationOption,
  fetchInquiryByRoster,
  fetchInquiryKind,
} from "@Services/api";
import { gaEvent } from "@Lib/ga";
import { IInquiryKind } from "@Types/inquiry";
import Barrage from "@Components/ask/Barrage";
import styles from "./price.module.less";
import InquiryForm, { FormParams } from "@Components/ask/inquiryForm";
import { IOptions } from "@Types/common";
import KindTypeDesc from "@Components/ask/kindTypeDesc";
import KindTypeSelect from "@Components/ask/kindTypeSelect";
import TradeInSelect from "@Components/ask/TradeInSelect";
import Crumbs from "@Components/ask/Crumbs";
import { appendParamsToUrl, g4 } from "../../utils/helper";
import { sendInquiryAds, sendInquiryAdsRemarketing, sendAgentAdsRemarketing } from "@Lib/adsRemarking";
import { Status_4_Result } from "@Components/buyCarMenu/Result.tsx";

const inquiryStoryLists: IOptions[] = [
  { name: "了解優惠", value: "1" },
  { name: "比較車款", value: "2" },
  { name: "預備購車", value: "3" },
  { name: "其他", value: "100" },
];

interface AskPricePageProps {}

export enum EAskPriceType {
  /** 名单广告 */
  ROSTER = "roster",
  /** 广告落地页 */
  AD = "ad",
}

const tip: any = {
  checkPrice: {
    title: "查成交價",
    bgColor: "linear-gradient(181deg,#dce9ff 0%, #ffffff 100%)",
    desc: "3個精選業代為您報價",
    color: "#3264FF",
    from: "single",
  },
  installment: {
    title: "分期購車",
    bgColor: "linear-gradient(180deg,#b9f1ef, rgba(255,255,255,0.00))",
    desc: "3個精選業代為您服務",
    color: "#0F9960",
    from: "loan",
  },
  subscribe: {
    title: "預約試駕",
    bgColor: "linear-gradient(181deg,#dce9ff 0%, #ffffff 100%)",
  },
  currentCar: {
    title: "現車查詢",
    bgColor: "linear-gradient(180deg,#dfe7ff, rgba(224,232,255,0.00))",
    desc: "3個精選業代為您服務",
    color: "#2F12B3",
    from: "currentCarPrice",
  },
  tradeIn: {
    title: "汰舊換新",
    bgColor: "linear-gradient(180deg,#96e6ff, rgba(255,255,255,0.00))",
    desc: "3個精選業代為您服務",
    color: "#097DB3",
    from: "replaceOld",
  },
  insurance: {
    title: "汽車保險",
    bgColor: " linear-gradient(180deg,#feecde, rgba(255,255,255,0.00))",
    desc: "3個精選業代為您服務",
    color: "#AB4400",
    from: "insurance",
  },
  bookDrive: {
    title: "預約試駕",
    bgColor: " linear-gradient(180deg,#feecde, rgba(255,255,255,0.00))",
    desc: "輕鬆到店試駕",
    color: "#AB4400",
    from: "bookDrive",
  },
};
// Main
const AskPricePage: React.FC<AskPricePageProps> = (props: AskPricePageProps) => {
  const [showKindSelect, toggleSelect] = useState(false);
  const [oldMyid, setOldMyid] = useState("");
  const [showCompeteModal, toggleCompeteModal] = useState(false);
  const [ads, setAds] = useState<any>({});

  const [modalData, setModalData] = useState<any>({
    inquiryId: "",
    buyCarInformationStatus: 0,
    activity: {},
    buyCarTime: 0,
    selectRegion: "",
    selectRegionAreas: "",
  });
  const [inquiryData, setInquiryData] = useLocalStorageState("inquiryData", {
    defaultValue: {},
  });
  const {
    globalSource,
    myid,
    b: urlBrandId,
    k: urlKindId,
    source: urlSource,
    type,
    kindType,
  } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const [pageState, setPageState] = useSetState({
    type,
  });

  const getCurrentSource = () => {
    if (isRoster) {
      return "廣告落地頁";
    }
    return undefined;
  };
  const source = getCurrentSource() || urlSource;
  // 外部页面可以管控b，k
  const [current, setCurrent] = useSetState({ b: urlBrandId, k: urlKindId });
  const { b, k } = current;
  const [contentWarning, setContentWarning] = useState("");
  // 名单广告不显示广告内容
  const isRoster = pageState.type === EAskPriceType.ROSTER;
  const [inquiryOptions, setInquiryOptions] = useSetState({
    buyCarTime: [] as IOptions[],
    contactTime: [] as IOptions[],
    inquiryStory: [] as IOptions[],
  });

  const [adBanner, setAdBanner] = useState("");
  /** 詢價車款數據 */
  const { data: kindData } = useQuery(["fetchInquiryKind", k], async () => {
    setPageState({ type: type ? type : "" });
    const res = await fetchInquiryKind({
      k,
      myid: myid || 0,
      from: tip[kindType as string]?.from || kindType || "",
    });
    if (!!res.data.type) {
      setPageState({ type: res.data.type });
    }
    if (!!res.data.adBanner) {
      setAdBanner(res.data.adBanner);
    }

    if (res?.status === 12000) {
      return res.data as IInquiryKind;
    }
    return {} as IInquiryKind;
  });

  const addMountRTBHEvents = () => {
    const userMessage = localStorage.getItem("userMessage");
    (window.rtbhEvents = window.rtbhEvents || []).push(
      {
        eventType: "startorder",
      },
      {
        eventType: "uid",
        id: window?.loginMid || (!!userMessage ? JSON.parse(userMessage).mId : "unknown"),
      },
    );
  };

  useMount(async () => {
    // 获取购车咨询选择内容
    const res = await fetchInquiryBuyCarInformationOption({ inquiryId: modalData.inquiryId });

    if (res?.status === 12000) {
      const { buyCarTime, contactTime, inquiryStory } = res?.data || {};
      setInquiryOptions({
        buyCarTime,
        contactTime,
        inquiryStory: inquiryStory || inquiryStoryLists,
      });
    }

    if (globalSource) {
      Cookies.set("globalSource", globalSource, { expires: 10 });
      Cookies.set("globalSessionSource", globalSource);
    }
    if (isObject(window)) {
      addMountRTBHEvents();
      window.onbeforeunload = () => {
        window.localStorage.setItem("test_onbeforeunload", "銷售線索");
        gaEvent("銷售線索", "一鍵詢價頁", "放棄詢價");
      };
    }
  });

  const handleSubmit = async (value: FormParams) => {
    const { source: querySource } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const {
      name,
      mobile,
      code,
      agencyAgreement,
      region,
      codeVerify,
      crossRegion,
      agreeCarResource,
      sex,
      buyCarTime,
      contactTime,
      regionName,
      inquiryStory,
      inquiryStoryRemark,
      isSeeCar,
      section,
      dealer,
      purchases,
      reason,
      email,
    } = value;

    const params = {
      b: b || kindData?.brandId,
      k: k || kindData?.kindId,
      myid,
      name,
      mobile,
      source: Cookies.get("globalSource") || source,
      entrance: querySource || "",
      sex,
      agencyAgreement,
      code,
      brandName: kindData?.brandName,
      kindName: kindData?.kindName,
      agreeCarResource,
      region: region,
      codeVerify,
      buyCarTime,
      oldMyid,
      crossRegion,
      regionName,
      contactTime,
      inquiryStory,
      inquiryStoryRemark,
      isSeeCar,
      section,
      dealer,
      purchases,
      reason,
      email,
    };

    g4("element_exposured", {
      page_name: "一鍵詢價頁",
      page_module: "詢價提醒彈窗",
      element: "放棄詢價",
      element_id: "放棄詢價",
      business: "銷售線索",
    });

    postInquiry(params);
  };

  const postInquiry = async (queryData: any) => {
    const {
      name,
      b,
      k,
      source,
      mobile,
      brandName,
      kindName,
      agencyAgreement,
      agreeCarResource,
      region,
      regionName,
      section,
      dealer,
      purchases,
      reason,
      email,
    } = queryData;

    const inquiryData = {
      element_id: source,
      brand_id: b,
      kind_id: k,
      model_id: "",
      brand: brandName,
      kind: kindName,
      model: "",
      inquiry_city: regionName,
      mobile_number: mobile,
      section,
      dealer,
      purchases,
      reason,
      email,
    };
    g4("inquiry_submit", inquiryData);

    const res = isRoster
      ? await fetchInquiryByRoster({ ...queryData })
      : await fetchInquiry({
          ...queryData,
        });
    if (res.status === 13001) {
      setContentWarning(res.data?.message);
      return;
    }
    // 请求错误直接提示
    if (res.status !== 12000) {
      message.error({ content: res.data.message || "係統錯誤", style: { marginTop: "20%" } });
      return;
    }

    if (res.status === 12000 && isRoster) {
      if (kindType === "checkPrice") {
        location.href = `/re-ask/price?rosterId=${res.data.id}&kindType=${kindType}`;
        return;
      }
      location.href = `/re-ask/price?rosterId=${res.data.id}&agreeCarResource=${agreeCarResource}&kindType=${kindType}`;
      return;
    }

    g4("inquiry_success", { ...inquiryData, inquiry_id: res.data.inquiryId });

    setInquiryData({
      name,
      mobile,
      agencyAgreement,
      codeVerify: 0,
      region: region,
    });

    setModalData({
      inquiryId: res.data.inquiryId,
      activity: res.data.activity,
      buyCarInformationStatus: res.data.buyCarInformationStatus,
      buyCarTime: res.data.buyCarTime,
      selectRegion: res.data.selectRegion,
      selectRegionAreas: res.data.selectRegionAreas,
    });

    addRTBHEvents(res.data.inquiryId, [k], res.data.mid);
    Cookies.set("isAskPrice", "true", { expires: 30 });
    localStorage.setItem("userMessage", JSON.stringify({ mId: res.data.mid }));
    if (res.data.noRepeatInquiry === 1) {
      gaEvent("銷售線索", "一鍵詢價頁", "詢價買家");
      if (window.fbq) {
        window.fbq("trackCustom", "新車-詢價-詢價買家");
      }
    }

    if (res.data.recommend.length !== 0) {
      gaEvent("銷售線索", "詢價-提交成功頁", "顯示");
    }

    gaEvent("銷售線索", "一鍵詢價頁", "我要詢價");

    // 增强型转化
    sendInquiryAds();

    // ADS再营销跟踪
    sendInquiryAdsRemarketing();

    // ADS再营销跟踪-業代優惠
    sendAgentAdsRemarketing();

    setTimeout(() => {
      if (kindType === "checkPrice") {
        location.href = `/re-ask/price?inquiryId=${res.data.inquiryId}&kindType=${kindType}`;
        return;
      }
      location.href = `/re-ask/price?inquiryId=${res.data.inquiryId}&agreeCarResource=${agreeCarResource}&kindType=${kindType}`;
    }, 200);
  };
  const addRTBHEvents = (inquiryId: string, kindsId: string[], m_id: string) => {
    if (!kindsId.length) return;
    (window.rtbhEvents = window.rtbhEvents || []).push(
      {
        eventType: "conversion",
        conversionClass: "action",
        conversionSubClass: "form",
        conversionId: inquiryId,
        offerIds: kindsId,
        conversionValue: 1,
        conversionCurrency: null,
      },
      {
        eventType: "uid",
        id: window?.loginMid || "unknown",
      },
    );
  };
  return (
    <section>
      {/* 白色找车标题区域 */}

      <Status_4_Result
        visible={!!contentWarning}
        content={contentWarning}
        onClose={() => {
          setContentWarning("");
        }}
      />

      {/* 主区域 */}
      <div className='w-full bg-[#F5F5F5] min-h-700'>
        <>
          <div>
            <Crumbs
              title={tip[kindType as string]?.title}
              b={b as string}
              k={k as string}
              brandName={kindData?.brandName}
              kindName={kindData?.kindName}
            />
          </div>
          <section className='relative block pb-30' style={{ background: "#F5F5F5" }}>
            <div className='w-1190 mx-auto bg-white'>
              <div
                className={`h-70 flex items-center -left-110 pl-30`}
                style={{
                  background: `url(https://assets.8891.com.tw/images/banner0909555.png) no-repeat center center / 100% 100%`,
                }}
              >
                <div className='text-30 font-[600] text-black'>{tip[kindType as string]?.title}</div>
                <div className='text-20 text-[#666] ml-16 relative top-2 font-normal'>
                  {kindType === "bookDrive"
                    ? tip[kindType as string]?.desc
                    : isRoster
                    ? ""
                    : tip[kindType as string]?.desc}
                </div>
              </div>
              <div className='w-1190 mx-auto overflow-hidden mt-10 mb-32'>
                <Barrage type={kindType} />
              </div>
              {/* 汰旧换新车 */}
              {kindType === "tradeIn" && (
                <TradeInSelect
                  showKindSelect={showKindSelect}
                  toggleSelect={toggleSelect}
                  oldMyid={oldMyid}
                  setOldMyid={setOldMyid}
                  kindData={kindData}
                  setCar={setCurrent}
                />
              )}
              <div className={"grid grid-cols-[440px_460px] gap-x-60"} style={{ padding: "0px 120px 60px" }}>
                {/* 左边显示车款 */}
                <KindTypeDesc kindData={kindData} adBanner={adBanner} />

                <div className={styles["list"]}>
                  <div>
                    {kindType !== "tradeIn" && (
                      // 厂牌车款筛选
                      <KindTypeSelect
                        showKindSelect={showKindSelect}
                        toggleSelect={toggleSelect}
                        kindData={kindData}
                        setCar={setCurrent}
                      />
                    )}
                    <InquiryForm
                      isRoster={pageState.type === "roster"}
                      toggleSelect={toggleSelect}
                      source={source as string}
                      kindData={kindData!}
                      inquiryData={inquiryData}
                      onSubmit={handleSubmit}
                      inquiryOptions={inquiryOptions}
                      type={(pageState.type || "") as string}
                      kindType={kindType as string}
                      isHideAnswerDate={!isRoster}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      </div>

      <CompeteModal visible={showCompeteModal} setVisible={toggleCompeteModal} data={ads} setData={setAds} />
    </section>
  );
};
export default AskPricePage;
